module.exports = __webpack_public_path__ + "static/media/blog-6.756d1f47.svg";